[
  {
    "tag": "7",
    "name": "BeginSeqNo",
    "type": "SeqNum",
    "description": "Message sequence number of first message in range to be resent"
  },
  {
    "tag": "8",
    "name": "BeginString",
    "type": "String",
    "description": "Identifies beginning of new message and protocol version. ALWAYS FIRST FIELD IN MESSAGE. (Always unencrypted)\nValid values:\nFIXT.1.1"
  },
  {
    "tag": "9",
    "name": "BodyLength",
    "type": "Length",
    "description": "Message length, in bytes, forward to the CheckSum field. ALWAYS SECOND FIELD IN MESSAGE. (Always unencrypted)"
  },
  {
    "tag": "10",
    "name": "CheckSum",
    "type": "String",
    "description": "Three byte, simple checksum (see Volume 2: \"Checksum Calculation\" for description). ALWAYS LAST FIELD IN MESSAGE; i.e. serves, with the trailing <SOH>, as the end-of-message delimiter. Always defined as three characters. (Always unencrypted)"
  },
  {
    "tag": "16",
    "name": "EndSeqNo",
    "type": "SeqNum",
    "description": "Message sequence number of last message in range to be resent. If request is for a single message BeginSeqNo (7) = EndSeqNo. If request is for all messages subsequent to a particular message, EndSeqNo = \"0\" (representing infinity)."
  },
  {
    "tag": "34",
    "name": "MsgSeqNum",
    "type": "SeqNum",
    "description": "Integer message sequence number."
  },
  {
    "tag": "35",
    "name": "MsgType",
    "type": "String",
    "description": "Defines message type ALWAYS THIRD FIELD IN MESSAGE. (Always unencrypted)\nNote: A \"U\" as the first character in the MsgType field (i.e. U, U2, etc) indicates that the message format is privately defined between the sender and receiver.\n*** Note the use of lower case letters ***",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Heartbeat",
        "description": "Heartbeat"
      },
      {
        "value": "1",
        "symbolicName": "TestRequest",
        "description": "Test Request"
      },
      {
        "value": "2",
        "symbolicName": "ResendRequest",
        "description": "Resend Request"
      },
      {
        "value": "3",
        "symbolicName": "Reject",
        "description": "Reject"
      },
      {
        "value": "4",
        "symbolicName": "SequenceReset",
        "description": "Sequence Reset"
      },
      {
        "value": "5",
        "symbolicName": "Logout",
        "description": "Logout"
      },
      {
        "value": "A",
        "symbolicName": "Logon",
        "description": "Logon"
      },
      {
        "value": "n",
        "symbolicName": "XMLnonFIX",
        "description": "XMLnonFIX"
      }
    ]
  },
  {
    "tag": "36",
    "name": "NewSeqNo",
    "type": "SeqNum",
    "description": "New sequence number"
  },
  {
    "tag": "43",
    "name": "PossDupFlag",
    "type": "Boolean",
    "description": "Indicates possible retransmission of message with this sequence number",
    "enum": [
      {
        "value": "N",
        "symbolicName": "OriginalTransmission",
        "description": "Original transmission"
      },
      {
        "value": "Y",
        "symbolicName": "PossibleDuplicate",
        "description": "Possible duplicate"
      }
    ]
  },
  {
    "tag": "45",
    "name": "RefSeqNum",
    "type": "SeqNum",
    "description": "Reference message sequence number"
  },
  {
    "tag": "49",
    "name": "SenderCompID",
    "type": "String",
    "description": "Assigned value used to identify firm sending message."
  },
  {
    "tag": "50",
    "name": "SenderSubID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator (desk, trader, etc.)"
  },
  {
    "tag": "52",
    "name": "SendingTime",
    "type": "UTCTimestamp",
    "description": "Time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "56",
    "name": "TargetCompID",
    "type": "String",
    "description": "Assigned value used to identify receiving firm."
  },
  {
    "tag": "57",
    "name": "TargetSubID",
    "type": "String",
    "description": "Assigned value used to identify specific individual or unit intended to receive message. \"ADMIN\" reserved for administrative messages not intended for a specific user."
  },
  {
    "tag": "58",
    "name": "Text",
    "type": "String",
    "description": "Free format text string\n(Note: this field does not have a specified maximum length)"
  },
  {
    "tag": "89",
    "name": "Signature",
    "type": "data",
    "description": "Electronic signature"
  },
  {
    "tag": "90",
    "name": "SecureDataLen",
    "type": "Length",
    "description": "Length of encrypted message"
  },
  {
    "tag": "91",
    "name": "SecureData",
    "type": "data",
    "description": "Actual encrypted data stream"
  },
  {
    "tag": "93",
    "name": "SignatureLength",
    "type": "Length",
    "description": "Number of bytes in signature field"
  },
  {
    "tag": "95",
    "name": "RawDataLength",
    "type": "Length",
    "description": "Number of bytes in raw data field."
  },
  {
    "tag": "96",
    "name": "RawData",
    "type": "data",
    "description": "Unformatted raw data, can include bitmaps, word processor documents, etc."
  },
  {
    "tag": "97",
    "name": "PossResend",
    "type": "Boolean",
    "description": "Indicates that message may contain information that has been sent under another sequence number.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "OriginalTransmission",
        "description": "Original Transmission"
      },
      {
        "value": "Y",
        "symbolicName": "PossibleResend",
        "description": "Possible Resend"
      }
    ]
  },
  {
    "tag": "98",
    "name": "EncryptMethod",
    "type": "int",
    "description": "Method of encryption.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "NoneOther",
        "description": "None / Other"
      },
      {
        "value": "1",
        "symbolicName": "PKCS",
        "description": "PKCS (Proprietary)"
      },
      {
        "value": "2",
        "symbolicName": "DES",
        "description": "DES (ECB Mode)"
      },
      {
        "value": "3",
        "symbolicName": "PKCSDES",
        "description": "PKCS / DES (Proprietary)"
      },
      {
        "value": "4",
        "symbolicName": "PGPDES",
        "description": "PGP / DES (Defunct)"
      },
      {
        "value": "5",
        "symbolicName": "PGPDESMD5",
        "description": "PGP / DES-MD5 (See app note on FIX web site)"
      },
      {
        "value": "6",
        "symbolicName": "PEMDESMD5",
        "description": "PEM / DES-MD5 (see app note on FIX web site)"
      }
    ]
  },
  {
    "tag": "108",
    "name": "HeartBtInt",
    "type": "int",
    "description": "Heartbeat interval (seconds)"
  },
  {
    "tag": "112",
    "name": "TestReqID",
    "type": "String",
    "description": "Identifier included in Test Request message to be returned in resulting Heartbeat"
  },
  {
    "tag": "115",
    "name": "OnBehalfOfCompID",
    "type": "String",
    "description": "Assigned value used to identify firm originating message if the message was delivered by a third party i.e. the third party firm identifier would be delivered in the SenderCompID field and the firm originating the message in this field."
  },
  {
    "tag": "116",
    "name": "OnBehalfOfSubID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator (i.e. trader) if the message was delivered by a third party"
  },
  {
    "tag": "122",
    "name": "OrigSendingTime",
    "type": "UTCTimestamp",
    "description": "Original time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\") when transmitting orders as the result of a resend request."
  },
  {
    "tag": "123",
    "name": "GapFillFlag",
    "type": "Boolean",
    "description": "Indicates that the Sequence Reset message is replacing administrative or application messages which will not be resent.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "SequenceResetIgnoreMsgSeqNum",
        "description": "Sequence Reset, Ignore Msg Seq Num (N/A For FIXML - Not Used)"
      },
      {
        "value": "Y",
        "symbolicName": "GapFillMessageMsgSeqNumFieldValid",
        "description": "Gap Fill Message, Msg Seq Num Field Valid"
      }
    ]
  },
  {
    "tag": "128",
    "name": "DeliverToCompID",
    "type": "String",
    "description": "Assigned value used to identify the firm targeted to receive the message if the message is delivered by a third party i.e. the third party firm identifier would be delivered in the TargetCompID (56) field and the ultimate receiver firm ID in this field."
  },
  {
    "tag": "129",
    "name": "DeliverToSubID",
    "type": "String",
    "description": "Assigned value used to identify specific message recipient (i.e. trader) if the message is delivered by a third party"
  },
  {
    "tag": "141",
    "name": "ResetSeqNumFlag",
    "type": "Boolean",
    "description": "Indicates that the both sides of the FIX session should reset sequence numbers.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "No",
        "description": "No"
      },
      {
        "value": "Y",
        "symbolicName": "YesResetSequenceNumbers",
        "description": "Yes, reset sequence numbers"
      }
    ]
  },
  {
    "tag": "142",
    "name": "SenderLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator’s location (i.e. geographic location and/or desk, trader)"
  },
  {
    "tag": "143",
    "name": "TargetLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message destination’s location (i.e. geographic location and/or desk, trader)"
  },
  {
    "tag": "144",
    "name": "OnBehalfOfLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator’s location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party"
  },
  {
    "tag": "145",
    "name": "DeliverToLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message recipient’s location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party"
  },
  {
    "tag": "212",
    "name": "XmlDataLen",
    "type": "Length",
    "description": "Length of the XmlData data block."
  },
  {
    "tag": "213",
    "name": "XmlData",
    "type": "data",
    "description": "Actual XML data stream (e.g. FIXML). See approriate XML reference (e.g. FIXML). Note: may contain embedded SOH characters."
  },
  {
    "tag": "347",
    "name": "MessageEncoding",
    "type": "String",
    "description": "Type of message encoding (non-ASCII (non-English) characters) used in a message’s \"Encoded\" fields."
  },
  {
    "tag": "354",
    "name": "EncodedTextLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedText (355) field."
  },
  {
    "tag": "355",
    "name": "EncodedText",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the Text (58) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Text field."
  },
  {
    "tag": "369",
    "name": "LastMsgSeqNumProcessed",
    "type": "SeqNum",
    "description": "The last MsgSeqNum (34) value received by the FIX engine and processed by downstream application, such as trading engine or order routing system. Can be specified on every message sent. Useful for detecting a backlog with a counterparty."
  },
  {
    "tag": "371",
    "name": "RefTagID",
    "type": "int",
    "description": "The tag number of the FIX field being referenced."
  },
  {
    "tag": "372",
    "name": "RefMsgType",
    "type": "String",
    "description": "The MsgType (35) of the FIX message being referenced."
  },
  {
    "tag": "373",
    "name": "SessionRejectReason",
    "type": "int",
    "description": "Code to identify reason for a session-level Reject message.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "InvalidTagNumber",
        "description": "Invalid Tag Number"
      },
      {
        "value": "1",
        "symbolicName": "RequiredTagMissing",
        "description": "Required Tag Missing"
      },
      {
        "value": "2",
        "symbolicName": "TagNotDefinedForThisMessageType",
        "description": "Tag not defined for this message type"
      },
      {
        "value": "3",
        "symbolicName": "UndefinedTag",
        "description": "Undefined tag"
      },
      {
        "value": "4",
        "symbolicName": "TagSpecifiedWithoutAValue",
        "description": "Tag specified without a value"
      },
      {
        "value": "5",
        "symbolicName": "ValueIsIncorrect",
        "description": "Value is incorrect (out of range) for this tag"
      },
      {
        "value": "6",
        "symbolicName": "IncorrectDataFormatForValue",
        "description": "Incorrect data format for value"
      },
      {
        "value": "7",
        "symbolicName": "DecryptionProblem",
        "description": "Decryption problem"
      },
      {
        "value": "8",
        "symbolicName": "SignatureProblem",
        "description": "Signature problem"
      },
      {
        "value": "9",
        "symbolicName": "CompidProblem",
        "description": "CompID problem"
      },
      {
        "value": "10",
        "symbolicName": "SendingtimeAccuracyProblem",
        "description": "SendingTime Accuracy Problem"
      },
      {
        "value": "11",
        "symbolicName": "InvalidMsgtype",
        "description": "Invalid MsgType"
      },
      {
        "value": "12",
        "symbolicName": "XMLValidationError",
        "description": "XML Validation Error"
      },
      {
        "value": "13",
        "symbolicName": "TagAppearsMoreThanOnce",
        "description": "Tag appears more than once"
      },
      {
        "value": "14",
        "symbolicName": "TagSpecifiedOutOfRequiredOrder",
        "description": "Tag specified out of required order"
      },
      {
        "value": "15",
        "symbolicName": "RepeatingGroupFieldsOutOfOrder",
        "description": "Repeating group fields out of order"
      },
      {
        "value": "16",
        "symbolicName": "IncorrectNumingroupCountForRepeatingGroup",
        "description": "Incorrect NumInGroup count for repeating group"
      },
      {
        "value": "17",
        "symbolicName": "NonDataValueIncludesFieldDelimiter",
        "description": "Non \"Data\" value includes field delimiter (<SOH> character)"
      },
      {
        "value": "18",
        "symbolicName": "InvalidUnsupportedApplicationVersion",
        "description": "Invalid/Unsupported Application Version"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "383",
    "name": "MaxMessageSize",
    "type": "Length",
    "description": "Maximum number of bytes supported for a single message."
  },
  {
    "tag": "464",
    "name": "TestMessageIndicator",
    "type": "Boolean",
    "description": "Indicates whether or not this FIX Session is a \"test\" vs. \"production\" connection. Useful for preventing \"accidents\".",
    "enum": [
      {
        "value": "N",
        "symbolicName": "Fales",
        "description": "Fales (Production)"
      },
      {
        "value": "Y",
        "symbolicName": "True",
        "description": "True (Test)"
      }
    ]
  },
  {
    "tag": "553",
    "name": "Username",
    "type": "String",
    "description": "Userid or username."
  },
  {
    "tag": "554",
    "name": "Password",
    "type": "String",
    "description": "Password or passphrase."
  },
  {
    "tag": "627",
    "name": "NoHops",
    "type": "NumInGroup",
    "description": "Number of HopCompID entries in repeating group."
  },
  {
    "tag": "628",
    "name": "HopCompID",
    "type": "String",
    "description": "Assigned value used to identify the third party firm which delivered a specific message either from the firm which originated the message or from another third party (if multiple \"hops\" are performed). It is recommended that this value be the SenderCompID (49) of the third party.\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or \"hubs\". Only applicable if OnBehalfOfCompID (115) is being used."
  },
  {
    "tag": "629",
    "name": "HopSendingTime",
    "type": "UTCTimestamp",
    "description": "Time that HopCompID (628) sent the message. It is recommended that this value be the SendingTime (52) of the message sent by the third party.\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or \"hubs\". Only applicable if OnBehalfOfCompID (115) is being used."
  },
  {
    "tag": "630",
    "name": "HopRefID",
    "type": "SeqNum",
    "description": "Reference identifier assigned by HopCompID (628) associated with the message sent. It is recommended that this value be the MsgSeqNum (34) of the message sent by the third party.\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or \"hubs\". Only applicable if OnBehalfOfCompID (115) is being used."
  },
  {
    "tag": "789",
    "name": "NextExpectedMsgSeqNum",
    "type": "SeqNum",
    "description": "Next expected MsgSeqNum value to be received."
  },
  {
    "tag": "925",
    "name": "NewPassword",
    "type": "String",
    "description": "New Password or passphrase"
  },
  {
    "tag": "1128",
    "name": "ApplVerID",
    "type": "String",
    "description": "Specifies the service pack release being applied at message level. Enumerated field with values assigned at time of service pack release",
    "enum": [
      {
        "value": "0",
        "symbolicName": "FIX27",
        "description": "FIX27"
      },
      {
        "value": "1",
        "symbolicName": "FIX30",
        "description": "FIX30"
      },
      {
        "value": "2",
        "symbolicName": "FIX40",
        "description": "FIX40"
      },
      {
        "value": "3",
        "symbolicName": "FIX41",
        "description": "FIX41"
      },
      {
        "value": "4",
        "symbolicName": "FIX42",
        "description": "FIX42"
      },
      {
        "value": "5",
        "symbolicName": "FIX43",
        "description": "FIX43"
      },
      {
        "value": "6",
        "symbolicName": "FIX44",
        "description": "FIX44"
      },
      {
        "value": "7",
        "symbolicName": "FIX50",
        "description": "FIX50"
      },
      {
        "value": "8",
        "symbolicName": "FIX50SP1",
        "description": "FIX50SP1"
      }
    ]
  },
  {
    "tag": "1129",
    "name": "CstmApplVerID",
    "type": "String",
    "description": "Specifies a custom extension to a message being applied at the message level. Enumerated field"
  },
  {
    "tag": "1130",
    "name": "RefApplVerID",
    "type": "String",
    "description": "Specifies the service pack release being applied to a message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID"
  },
  {
    "tag": "1131",
    "name": "RefCstmApplVerID",
    "type": "String",
    "description": "Specifies a custom extension to a message being applied at the session level."
  },
  {
    "tag": "1137",
    "name": "DefaultApplVerID",
    "type": "String",
    "description": "Specifies the service pack release being applied, by default, to message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID"
  },
  {
    "tag": "1156",
    "name": "ApplExtID",
    "type": "int",
    "description": "The extension pack number associated with an application message."
  },
  {
    "tag": "1400",
    "name": "EncryptedPasswordMethod",
    "type": "int",
    "description": "Enumeration defining the encryption method used to encrypt password fields.\nAt this time there are no encryption methods defined by FPL."
  },
  {
    "tag": "1401",
    "name": "EncryptedPasswordLen",
    "type": "Length",
    "description": "Length of the EncryptedPassword(1402) field"
  },
  {
    "tag": "1402",
    "name": "EncryptedPassword",
    "type": "data",
    "description": "Encrypted password - encrypted via the method specified in the field EncryptedPasswordMethod(1400)"
  },
  {
    "tag": "1403",
    "name": "EncryptedNewPasswordLen",
    "type": "Length",
    "description": "Length of the EncryptedNewPassword(1404) field"
  },
  {
    "tag": "1404",
    "name": "EncryptedNewPassword",
    "type": "data",
    "description": "Encrypted new password - encrypted via the method specified in the field EncryptedPasswordMethod(1400)"
  },
  {
    "tag": "1406",
    "name": "RefApplExtID",
    "type": "int",
    "description": "The extension pack number associated with an application message."
  },
  {
    "tag": "1407",
    "name": "DefaultApplExtID",
    "type": "int",
    "description": "The extension pack number that is the default for a FIX session."
  },
  {
    "tag": "1408",
    "name": "DefaultCstmApplVerID",
    "type": "String",
    "description": "The default custom application version ID that is the default for a session."
  },
  {
    "tag": "1409",
    "name": "SessionStatus",
    "type": "int",
    "description": "Status of a FIX session",
    "enum": [
      {
        "value": "0",
        "symbolicName": "SessionActive",
        "description": "Session active"
      },
      {
        "value": "1",
        "symbolicName": "SessionPasswordChanged",
        "description": "Session password changed"
      },
      {
        "value": "2",
        "symbolicName": "SessionPasswordDueToExpire",
        "description": "Session password due to expire"
      },
      {
        "value": "3",
        "symbolicName": "NewSessionPasswordDoesNotComplyWithPolicy",
        "description": "New session password does not comply with policy"
      },
      {
        "value": "4",
        "symbolicName": "SessionLogoutComplete",
        "description": "Session logout complete"
      },
      {
        "value": "5",
        "symbolicName": "InvalidUsernameOrPassword",
        "description": "Invalid username or password"
      },
      {
        "value": "6",
        "symbolicName": "AccountLocked",
        "description": "Account locked"
      },
      {
        "value": "7",
        "symbolicName": "LogonsAreNotAllowedAtThisTime",
        "description": "Logons are not allowed at this time"
      },
      {
        "value": "8",
        "symbolicName": "PasswordExpired",
        "description": "Password expired"
      }
    ]
  }
]
